import React, { useState, useEffect } from 'react';
import { INDEX_URL, CUST, icons } from "../../helpers/constants";
import { Card, Collapse, Dialog } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { staticSort } from '../../helpers/helperFunctions';

const Searchbar = ( {devices, visibleEvents, submitSearch, currentOrder, updateOrder, updateTypes, updateDevices, clearSearch, error, className, sort } ) => {
    const { t } = useTranslation();
    const location = useLocation();
    const [searchKey, setSearchKey] = useState("");
    const [showSort, setShowSort] = useState(false);
    const [pageSpecific, setPageSpecific] = useState(location.pathname)
    const [eventTypes, setEventTypes] = useState([]);
    const [innerDevices, setInnerDevices] = useState()

    useEffect(() => {
        if(eventTypes?.length === 0 && pageSpecific === "/events"){
            const filtered = Object?.entries(visibleEvents?.events)
            .filter(([key, value]) => value === true)
            .map(([key]) => ({
                type: key,
                name: visibleEvents.translations[key], // or typeTranslations[key] if needed
                selected: false
            }));
            setEventTypes(filtered);
        }

    }, [visibleEvents?.events]);

    useEffect(() => {
        setInnerDevices(devices)
    }, [devices])

    const handleChange = (field, e) => {
		setSearchKey(e.target.value);
    };

	const onKeyDown = (e) => {
		const { key } = e;
		if (key === "Enter" && searchKey.length > 0) {
			submitSearch(searchKey)
            clearSelected()
		}
	}


	useEffect(() => {
		if(searchKey.length == 0){
			if(submitSearch){
				submitSearch("")
			}
		}
	}, [searchKey])
    
	const openSort = () => {
		setShowSort(!showSort)
	}

	const updateFilter = (type) => {
        const changeOrder = type === currentOrder?.type
        if(pageSpecific == "/events"){
            const order = changeOrder
                ? (currentOrder?.order === "latest" ? "oldest" : "latest")
                : "latest"; // default when changing type
            updateOrder({type: type, order: order})  
        }else{
            const order = changeOrder
                ? (currentOrder?.order === "asc" ? "desc" : "asc")
                : "asc"; // default when changing type
            updateOrder({type: type, order: order})
        }
	}

    const updateEventFilter = (type) => {
        // Create a new array with updated `selected` status
        const updatedEventTypes = eventTypes.map(eventType => 
            eventType.type === type 
                ? { ...eventType, selected: !eventType.selected } // Toggle `selected` for the matching type
                : eventType // Leave other types unchanged
        );
    
        // Update `props.updateTypes` with the new array if it's available
        if (updateTypes) {
            updateTypes(updatedEventTypes);
            setEventTypes(updatedEventTypes);
            setSearchKey("")
        }
        
        // Update local state
    };

    const updateDeviceFilter = (id) => {
        // Create a new array with updated `selected` status
        const filtering = innerDevices.map(device => 
            device.id === id 
                ? { ...device, selected: !device.selected } // Toggle `selected` for the matching device
                : device // Leave other devices unchanged
        );
    
        // Call `props.updateDevices` with the updated array if it's available
        if (updateDevices) {
            updateDevices(filtering);
            setInnerDevices(filtering)
            setSearchKey("")
        }
    };

    const clearSelected = () => {
        if(devices){
            setInnerDevices((prevState) => 
                prevState.map(device => ({
                    ...device,          // Spread the existing properties of the device
                    selected: false     // Override the `selected` property to be false
                }))
            );  
        }
        if(eventTypes){
            setEventTypes((prevState) =>
                prevState.map(event => ({
                    ...event,
                    selected: false
                }))
            );
        }
    }

    // useEffect(() => {
    //     if(props.updateDevices){
    //         props.updateDevices(devices)
    //     }        
    // }, [devices])


    useEffect(() => {
        staticSort(devices, "name")     
    }, [devices])


    useEffect(() => {
        setSearchKey("")
        clearSelected()
        
    }, [clearSearch])



    
    

    const renderCardEvents = () => (
        <Card className={`py-0 px-1 mt-1 mb-2 sortCollapse`}>
        <div className="d-flex flex-row justify-content-between px-1 pt-3 border-bottom">
            <h4 className="mb-2">{t("search.sort_by_date")}</h4>
            <img
                className="size_20 right_7 cursor-pointer close_img"
                src={icons.close_gray}
                onClick={() =>setShowSort(!showSort)}
                alt="..."
            />
        </div>
        <ul className="list-group list-group-flush">
            <li
                className="cursor-pointer list-group-item d-flex justify-content-between align-items-center"
                onClick={() => {
                    updateFilter("date")
                // changeSortOrder("name")
                }}
            >
            <p className={`my-2 ${currentOrder?.type === "date" ? "text-navy" : "text-gray"}`}>
                {t("search.date")}
                <img src={icons.sort_arrow} className={`ms-2 ${currentOrder?.type !== "date" ? "d-none" : ""} ${currentOrder?.order === "latest" && "rotate-180"}`} alt={""}/>
            </p>
            </li>
        </ul>
        <div className="d-flex flex-row justify-content-between px-1 pt-3 border-bottom">
            <h4 className="mb-2">{t("search.sort_type")}</h4>
        </div>
        <ul className="list-group list-group-flush sort-event-list">
            {eventTypes.map((eventtype, index) => (

            <li
                key={index}
                className="cursor-pointer list-group-item d-flex justify-content-between align-items-center"
                onClick={() => {
                    updateEventFilter(eventtype.type)
                // changeSortOrder("name")
                }}
            >
                <div className="d-flex justify-content-between w-100 align-items-center">
                    <p className={`my-2 ${eventtype.selected ? "text-navy bold" : "text-gray"}`}>{eventtype.name}</p>
                    {eventtype.selected &&
                    <img src={icons.check} className="size_15 me-3" alt=""/>
                    }
                </div>
            </li>
            ))}
        </ul>

        <div className="d-flex flex-row justify-content-between px-1 pt-3 border-bottom">
            <h4 className="mb-2">{t("search.sort_device")}</h4>
        </div>
        <ul className="list-group list-group-flush sort-event-list">
            {innerDevices?.map((device, index) => (
            <li
                key={index}
                className="cursor-pointer list-group-item d-flex justify-content-between align-items-center"
                onClick={() => {
                    updateDeviceFilter(device.id)
                // changeSortOrder("name")
                }}
            >
                <div className="d-flex justify-content-between w-100 align-items-center">
                    <p className={`my-2 ${device.selected ? "text-navy bold" : "text-gray"}`}>{t(device.name)}</p>
                    {device.selected &&
                    <img src={icons.check} className="size_15 me-3" alt=""/>
                    }
                </div>
            </li>
            ))}
        </ul>
    </Card>
    )

    const renderCardDevices = () => (
        <Card className={`py-0 px-1 mt-1 mb-2 shadow-medium`}>
            <div className="d-flex flex-row justify-content-between align-items-center px-2 pt-3 pb-2 border-bottom">
                <h4 className="mb-2 primary">{t("search.sort_device")}</h4>
                <img
                    className="mb-2 size_25 cursor-pointer close_img"
                    src={icons.close_gray}
                    onClick={() =>setShowSort(!showSort)}
                    alt="..."
                />
            </div>
        <ul className="list-group list-group-flush">
            <li
                className="cursor-pointer list-group-item d-flex justify-content-between align-items-center px-2"
                onClick={() => {
                    updateFilter("name")
                // changeSortOrder("name")
                }}
            >
            {/* <p className={`my-2 ${sortState.sortOrder != "" && sortState.sort === "name" ? "text-navy" : "text-gray"
              }`}
            > */}
            <p className={`my-2 primary ${currentOrder?.type === "name" ? "primary bold" : "dark_grey"}`}>
				{t("search.name")}
				<img src={icons.sort_arrow} className={`ms-2 size_15 primary-icon ${currentOrder?.type !== "name" ? "d-none" : ""} ${currentOrder?.order === "asc" && "rotate-180"}`} alt={""}/>
            </p>
            </li>
            <li
                className="cursor-pointer list-group-item d-flex justify-content-between align-items-center px-2"
                onClick={() => {
					updateFilter("status")
                // changeSortOrder("name")
                }}
            >
            <p className={`my-2 primary ${currentOrder?.type === "status" ? "primary bold" : "dark_grey"}`}>
                {t("search.status")}
				<img src={icons.sort_arrow} className={`ms-2 size_15 primary-icon ${currentOrder?.type !== "status" ? "d-none" : ""} ${currentOrder?.order === "asc" && "rotate-180"}`} alt={""}/>
            </p>
            </li>
            <li
                className="cursor-pointer list-group-item d-flex justify-content-between align-items-center px-2"
                onClick={() => {
					updateFilter("groups")
                // changeSortOrder("name")
                }}
            >
            <p className={`my-2 primary ${currentOrder?.type === "groups" ? "primary bold" : "dark_grey"}`}>
                {t("search.groups")}
				<img src={icons.sort_arrow} className={`ms-2 size_15 primary-icon ${currentOrder?.type !== "groups" ? "d-none" : ""} ${currentOrder?.order === "asc" && "rotate-180"}`} alt={""}/>
            </p>
            </li>
			{/* <li
                className="cursor-pointer list-group-item d-flex justify-content-between align-items-center px-2"
                onClick={() => {
					updateFilter("lastupdate")
                // changeSortOrder("name")
                }}
            >
            <p className={`my-2 primary ${currentOrder?.type === "lastupdate" ? "primary bold" : "dark_grey"}`}>
                {t("search.last_update")}
				<img src={icons.sort_arrow} className={`ms-2 size_15 primary-icon ${currentOrder?.type !== "lastupdate" ? "d-none" : ""} ${currentOrder?.order === "asc" && "rotate-180"}`} alt={""}/>
            </p>
            </li> */}
        </ul>
        </Card>
    )
    
    return(
        <>
        <div className={`d-flex flex-column ${className ? className : ""}`}>
            <div className={"p-2 search_bar position-relative"}>
                <img
                src={icons.search}
                className="cursor-pointer"
                onClick={() => submitSearch(searchKey)}
                alt="..."
                />
                <input
                    autoComplete="off"
                    type="text"
                    className={`form-control input-search p ${error ? "is-invalid" : ""}`}
                    id="newName"
                    value={searchKey}
                    onKeyDown={onKeyDown}
                    onChange={(e) => {
                        handleChange("SearchKey", e);
                    }}
                    placeholder={t("search.search")}
                />
                {sort &&
                <img
                    src={icons.sort_button}
                    className="cursor-pointer search_bar_sort_icon"
                    onClick={() => openSort()}
                    alt="..."
                />
                }

            <Collapse in={showSort} className="position-absolute top-100 w-100" style={{zIndex: "9999"}}>
                {pageSpecific == "/devices"
                    ? renderCardDevices()
                    : pageSpecific == "/events"
                    ? renderCardEvents()
                    : null
                }
            </Collapse> 
			</div>

        </div>
        </>
    )
}

export default Searchbar;